import { useDispatch, useSelector } from 'react-redux';
import {
  setHighlightedColumns,
  setHighlightedRows,
} from '../store/actions/rsoImportActions';
import { useCallback, useEffect } from 'react';
import { nameTableColumn, nameTableRows } from '../constants/nameTableRso';

const useSyncRsoForm = (form) => {
  const valueForm = useSelector((state) => state.rsoImportStore.valueForm);

  const dispatch = useDispatch();

  const onChangeColumnItem = useCallback(
    (fieldName, val) => {
      dispatch(setHighlightedColumns(fieldName, val));
    },
    [dispatch]
  );

  useEffect(() => {
    if (!Object.keys(valueForm || {}).length) return;

    dispatch(setHighlightedRows(nameTableRows.firstRow, valueForm.firstRow));
    dispatch(setHighlightedRows(nameTableRows.headerRow, valueForm.headerRow));

    onChangeColumnItem(
      nameTableColumn.columnSerialNumber,
      valueForm.columnSerialNumber
    );

    onChangeColumnItem(
      nameTableColumn.columnMeterReading,
      valueForm.columnMeterReading
    );

    onChangeColumnItem(nameTableColumn.columnDate, valueForm.columnDate);

    if (valueForm.columnTariff) {
      onChangeColumnItem(nameTableColumn.columnTariff, valueForm.columnTariff);
    }

    const addresses = valueForm.columnsAddress || [];
    if (addresses.length === 1) {
      onChangeColumnItem(nameTableColumn.columnsAddressStart, addresses[0]);
    } else if (addresses.length > 1) {
      onChangeColumnItem(nameTableColumn.columnsAddressStart, addresses[0]);
      onChangeColumnItem(
        nameTableColumn.columnsAddressEnd,
        addresses[addresses.length - 1]
      );
    }
  }, []);
};

export default useSyncRsoForm;
